<template>
    <div>
        <template v-if="loading">
            <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                bottom
                color="#db5120"
            ></v-progress-linear>
        </template>
        <template v-else>
            <v-card elevation="2" class="mb-5">
                <v-list>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-subtitle>Status:</v-list-item-subtitle>
                            <v-list-item-title>{{ ticket.status }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-subtitle>Subject:</v-list-item-subtitle>
                            <v-list-item-title>{{ ticket.subject }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-subtitle>Ticket ID:</v-list-item-subtitle>
                            <v-list-item-title>{{ ticket.ticketId }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-subtitle>Updated By:</v-list-item-subtitle>
                            <v-list-item-title>{{
                                ticket.updateBy && ticket.updateBy.name && ticket.updateBy.email
                                    ? `${ticket.updateBy.name} (${ticket.updateBy.email})`
                                    : 'NA'
                            }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card>
            <v-expansion-panels>
                <v-expansion-panel v-for="(item, i) in ticket.messages" :key="i">
                    <v-expansion-panel-header class="pt-0 pb-0 text-overline">
                        {{ item.by.name }} ({{ item.by.email }}): {{ item.subject }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content
                        v-if="item.attachments && item.attachments.length > 0"
                        style="border-top: 2px solid #db5120"
                        class="pt-5 pr-5 pl-3"
                        ><v-icon small>{{ mdiPaperclip }}</v-icon
                        ><span class="ml-1 subtitle-font">Attachments ({{ item.attachments.length }}):</span>
                        <v-container fluid>
                            <v-row>
                                <v-col v-for="attachment in item.attachments" :key="attachment.id" cols="4">
                                    <!-- <img
                                        :src="attachment.url"
                                        :alt="attachment.filename"
                                        class="image"
                                        height="100%"
                                        width="100%"
                                    /> -->
                                    <a :href="attachment.url" target="_blank">{{ attachment.filename }}</a>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-expansion-panel-content>
                    <!-- <v-expansion-panel-content
                        class="pt-0 pr-10 pl-10 pb-10"
                        style="overflow: scroll"
                        v-html="fixFormatting(item.html, item.attachments)"
                    >
                    </v-expansion-panel-content> -->
                    <v-expansion-panel-content class="mt-5">
                        <iframe
                            width="100%"
                            height="500px"
                            :srcdoc="fixFormatting(item.html, item.attachments)"
                        ></iframe>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </template>
    </div>
</template>

<script>
import gql from 'graphql-tag'
import { mdiPaperclip } from '@mdi/js'

export default {
    metaInfo: { title: `Your Account`, subTitle: `Dashboard` },
    name: `HfTicket`,
    props: {
        ticketId: {
            type: String,
            required: false,
            default: ``
        },
        isOpen: {
            type: Boolean,
            required: true
        }
    },
    apollo: {
        queryHFTicket: {
            variables() {
                return {
                    ticketId: this.ticketId
                }
            },
            skip() {
                return !this.ticketId
            },
            query: gql`
                query QueryHFTicket($ticketId: String!) {
                    queryHFTicket(ticketId: $ticketId) {
                        messages {
                            text
                            subject
                            html
                            by {
                                name
                                email
                            }
                            attachments {
                                filename
                                id
                                url
                            }
                        }
                        status
                        subject
                        ticketId
                        updateBy {
                            name
                            email
                        }
                    }
                }
            `,
            update(data) {
                this.ticket = data.queryHFTicket
                this.loading = false
            }
        }
    },
    data() {
        return {
            mdiPaperclip,
            loading: true,
            ticket: null
        }
    },
    computed: {},
    watch: {
        isOpen: {
            handler(v) {
                if (!v) {
                    this.loading = true
                    this.ticket = null
                }
            }
        }
    },

    methods: {
        replaceImgs(email, attachments) {
            const div = document.createElement('div')
            div.innerHTML = email
            const images = div.getElementsByTagName('img')
            for (let i = 0; i < images.length; i++) {
                const src = images[i].src
                const found = attachments.find((e) => src.includes(e.id))
                if (found) {
                    images[i].src = found.url
                }
            }
            return div.innerHTML
            // images.forEach((e) => {
            //     e.remove()
            // })
            // return div.innerHTML
        },
        fixFormatting(email, attachments) {
            const find = `<table border="1" cellpadding="0" cellspacing="0" class="x_MsoNormalTable" style="width: 100.0%; background: #EA1A1A;" width="100%">
<tbody>
<tr>
<td style="background: aqua; padding: 0in 0in 0in .05in;">
<p class="x_MsoNormal"><span style='font-family: "Arial",sans-serif; color: black;'>External email – make sure you trust this source before opening links/attachment.
</span><span style='font-family: "Times New Roman",serif; color: white;'> </span></p>
</td>
</tr>
</tbody>`

            let result = email.replace(find, '')
            if (attachments && attachments.length > 0) {
                result = this.replaceImgs(result, attachments)
            }
            return result
        }
    }
}
</script>
